const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

let googleScriptPromise;
let googleInitialized = false;
let activeHandlers = { onSuccess: null, onError: null };

function loadGoogleScript() {
  if (googleScriptPromise) return googleScriptPromise;

  googleScriptPromise = new Promise((resolve, reject) => {
    if (window.google && window.google.accounts && window.google.accounts.id) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    script.onload = () => {
      if (
        window.google &&
        window.google.accounts &&
        window.google.accounts.id
      ) {
        resolve();
      } else {
        reject(new Error("Google Identity Services failed to load"));
      }
    };
    script.onerror = () =>
      reject(new Error("Failed to load Google Identity Services"));

    document.head.appendChild(script);
  });

  return googleScriptPromise;
}

export async function renderGoogleSignInButton(
  container,
  { onSuccess, onError } = {}
) {
  if (!GOOGLE_CLIENT_ID) {
    throw new Error("Missing REACT_APP_GOOGLE_CLIENT_ID");
  }

  if (!container) {
    throw new Error("Missing Google button container");
  }

  await loadGoogleScript();

  if (!window.google || !window.google.accounts || !window.google.accounts.id) {
    throw new Error("Google Identity Services not available");
  }

  activeHandlers = { onSuccess, onError };

  if (!googleInitialized) {
    window.google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback: (response) => {
        if (response && response.credential) {
          activeHandlers.onSuccess?.(response.credential);
        } else {
          activeHandlers.onError?.(
            new Error("Google sign-in failed: no credential")
          );
        }
      },
      ux_mode: "popup",
      context: "signin",
    });
    googleInitialized = true;
  }

  container.innerHTML = "";
  window.google.accounts.id.renderButton(container, {
    theme: "outline",
    size: "large",
    text: "signin_with",
    shape: "rectangular",
    width: container.offsetWidth || 320,
  });
}

export async function getGoogleIdToken() {
  throw new Error(
    "getGoogleIdToken is deprecated. Use renderGoogleSignInButton instead."
  );
}
